// The order a customer has been sent to PayFast to pay for. It is saved just
// before the redirect so the return page can confirm the payment and, if they
// cancel or abandon, the site can remind them the order is still unpaid.
const STORAGE_KEY = 'parcelin_pending_order';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export const savePendingOrder = ({ value, reference, paymentUrl = null }) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ value, reference, paymentUrl, savedAt: Date.now() }),
    );
  } catch {
    // Storage can be unavailable (private mode); payment still proceeds.
  }
};

export const clearPendingOrder = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear.
  }
};

export const readPendingOrder = () => {
  let stored;
  try {
    stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
  if (!stored?.reference) return null;
  if (stored.savedAt && Date.now() - stored.savedAt > MAX_AGE_MS) {
    clearPendingOrder();
    return null;
  }
  return stored;
};
